
import { defineComponent } from "vue";

export default defineComponent({
  name: "vz-show-icon",
});
